import { useTranslation } from "react-i18next"

import { Checkbox } from "@/components/ui/checkbox"
import { Label } from "@/components/ui/label"
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip"
import { useAISettingsStore } from "@/stores/ai-settings-store"

export function ContextualActionsCheckbox() {
  const { t } = useTranslation()

  const enableContextualActions = useAISettingsStore(
    (state) => state.settings.enableContextualActions
  )
  const changeSettings = useAISettingsStore((state) => state.changeSettings)

  function handleCheckedChange(checked: boolean) {
    changeSettings({ enableContextualActions: checked })
  }

  return (
    <section className="flex items-center gap-2">
      <Checkbox
        checked={enableContextualActions}
        id="contextual-actions"
        onCheckedChange={handleCheckedChange}
      />
      <Tooltip>
        <TooltipTrigger>
          <Label htmlFor="contextual-actions">
            {t("pages.common.contextual_actions", {
              defaultValue: "Contextual actions on marked text",
            })}
          </Label>
        </TooltipTrigger>
        <TooltipContent className="max-w-[250px]" side="top">
          <p>
            {t("settingsmenu.contextual_actions_tooltip", {
              defaultValue:
                "Show a menu with actions when you select text in chat messages, allowing quick access to tools like web search, research, and more.",
            })}
          </p>
        </TooltipContent>
      </Tooltip>
    </section>
  )
}
